import { Box, Button, HStack, Tag, Text } from '@chakra-ui/react'
import { filter, isEmpty, some } from 'lodash'
import { useMemo, useState } from 'react'
import { useBoolean } from 'react-use'
import { Modal, Select } from 'uikit'
import { allowedRoles } from '../../constants/allowedRoles'
import { useRoleMappingsAdd } from './useRoleMappingsAdd'
import { useRoleMappingsDelete } from './useRoleMappingsDelete'
import { useRoleMappingsFetch } from './useRoleMappingsFetch'
import { useRolesListFetch } from './useRolesListFetch'

export const Role = ({ id }) => {
  const [isOpen, setIsOpen] = useBoolean(false)
  const [value, setValue] = useState({})
  const { data: rolesList } = useRolesListFetch()
  const { data, refetch: fetchRoleMappingItem } = useRoleMappingsFetch(id)
  const { mutate: createUserRole, isPending: isLoadingCreateUser } = useRoleMappingsAdd(id)
  const { mutate: deleteUserRole } = useRoleMappingsDelete(id)

  const valueList = useMemo(() => {
    if (isEmpty(data)) {
      return
    }
    const list = filter(data?.data?.realmMappings, (e) => allowedRoles.includes(e.name))
    return list.map((i) => ({ label: i.name, value: i.id }))
  }, [data])

  const optionsList = useMemo(() => {
    const list = filter(rolesList?.data, (e) => {
      return allowedRoles.includes(e.name) && !some(valueList, { label: e.name, value: e.id })
    })
    return list.map((i) => ({ label: i.name, value: i.id }))
  }, [rolesList, valueList])

  const handleClose = () => {
    setIsOpen(false)
    setValue({})
  }

  const handleAddRole = () => {
    const payload = [
      {
        id: value.value,
        name: value.label,
      },
    ]
    createUserRole(payload, {
      onSuccess: () => {
        fetchRoleMappingItem()
        handleClose()
      },
    })
  }

  const handleDeleteRole = (e) => {
    const payload = [
      {
        id: e.value,
        name: e.label,
      },
    ]
    deleteUserRole(payload, {
      onSuccess: () => {
        fetchRoleMappingItem()
      }
    })
  }

  return (
    <>
      {isEmpty(valueList) ? (
        <Text>Для данного пользователя роли не назначены</Text>
      ) : (
        <HStack alignItems="flex-start">
          {valueList?.map((item) => (
            <Tag.Root key={item.value} borderRadius="full" variant="solid" colorPalette="orange">
              <Tag.Label>{item.label}</Tag.Label>
              <Tag.CloseTrigger onClick={() => handleDeleteRole(item)} />
            </Tag.Root>
          ))}
        </HStack>
      )}
      <Box>
        <Button colorPalette="gray" onClick={() => setIsOpen(true)} size="sm">
          Добавить роль
        </Button>
      </Box>
      <Modal
        isOpen={isOpen}
        onClose={handleClose}
        title="Добавление роли"
        footer={
          <Button colorPalette="orange" loading={isLoadingCreateUser} onClick={handleAddRole}>
            Добавить
          </Button>
        }
      >
        <Select
          autoFocus
          isSearchable={false}
          placeholder="Выберите роль"
          name="value"
          value={value.value}
          options={optionsList}
          onChange={(e) => setValue(e)}
          label="Роли"
        />
      </Modal>
    </>
  )
}
